import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { computed } from "@vue/composition-api";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
export const useAssetFieldVisibility = options => {
  const {
    computeSchemaVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentAssetPath = computed(() => {
    return `${currentApplicantPath.value}[assets][${options.assetIndex.value}]`;
  });
  const currentAssetVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = currentAssetPath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const isApplicantVisibleFromFillOut = computed(() => {
    var _options$applicantId;
    return computeFillOutVisibility(APPLICATION_STEPS.ASSETS, {
      applicantId: (_options$applicantId = options.applicantId) == null ? void 0 : _options$applicantId.value
    }).value;
  });
  const assetTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentAssetVisibilityPath.value + "[type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const assetDescriptionVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentAssetVisibilityPath.value + "[description]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const assetAmountVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentAssetVisibilityPath.value + "[amount]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const isAssetSectionVisibleForApplicant = computed(() => {
    return assetTypeVisible.value || assetAmountVisible.value || assetDescriptionVisible.value;
  });
  return {
    assetTypeVisible,
    assetDescriptionVisible,
    assetAmountVisible,
    isAssetSectionVisibleForApplicant
  };
};